import { Component, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';

import {
  RadioQuestionModel,
  ContraventionQuestionModel,
  SelectQuestionModel,
  MultipleQuestionModel,
} from '../../../viewmodels/policy-item.model';
import { DisabledCopy } from '../../../helper/textcopy/policies.text';
import { Subscription } from 'rxjs';
import { GlobalObservables } from '../../../../../app.global.observer';
import { HelperService } from '../../../services/helper.service';
import { Global } from '../../../../../app.global';
import { ReportsService } from '../../../services/reports.service';
import { KeyDescriptionViewModel } from '../../../viewmodels/keyDescriptionViewModel';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'disabled-policy',
  templateUrl: './disabled.component.html',
})
export class DisabledComponent implements OnInit, OnDestroy {
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSavePolicies = new EventEmitter();
  textCopy = DisabledCopy;
  policiesAnswersSetted = new Subscription();
  policiesAnswers: any = this.global.policiesAnswers;

  secondRadioQuestion = new RadioQuestionModel();
  contraventionsQuestion = new ContraventionQuestionModel();
  thirdSelectQuestion = new SelectQuestionModel();
  badgeMultipleQuestions = new MultipleQuestionModel();
  clockMultipleQuestions = new MultipleQuestionModel();
  furtherInfoRadioQuestion = new RadioQuestionModel();
  furtherInfoTextarea = '';

  constructor(
    public global: Global,
    private globalObs: GlobalObservables,
    private helpServ: HelperService,
    private reportsService: ReportsService
  ) {}

  ngOnInit() {
    this.setSecondRadioQuestion();
    this.setContraventionsQuestion();
    this.setThirdSelectQuestion();
    this.setBadgeMultipleSelectQuestion();
    this.setClockMultipleSelectQuestion();
    this.setFurtherInfoRadioQuestion();

    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.onPoliciesAnswersSetted();
    } else {
      this.setSelectedValues();
    }
  }

  setContraventionsQuestion() {
    this.contraventionsQuestion.options = [
      { value: 'y', text: 'Y' },
      { value: 'n', text: 'N' },
      { value: 'q', text: 'Q' },
    ];
  }
  onContraventionsQuestionSelected(answerValue) {
    this.contraventionsQuestion.valuesSelected = answerValue;
    this.contraventionsQuestion.valuesSelected = this.contraventionsQuestion.valuesSelected.slice();
  }

  setSecondRadioQuestion() {
    this.secondRadioQuestion.data = {
      title: this.textCopy.secontTitle,
      includeTitle: true,
      answers: [
        {
          text: 'yes',
          value: 'y',
        },
        {
          text: 'no',
          value: 'n',
        },
      ],
    };
  }
  onSecondRadioQuestionSelected(answerValue) {
    this.secondRadioQuestion.valueSelected = answerValue;
  }

  setThirdSelectQuestion() {
    this.thirdSelectQuestion.data = {
      title: this.textCopy.thirdTitle,
      includeTitle: true,
      answers: [
        {
          id: '0',
          value: '1',
        },
        {
          id: '1',
          value: '2',
        },
        {
          id: '2',
          value: '3',
        },
      ],
    };
  }
  onThirdSelectQuestionSelected(answerValue) {
    this.thirdSelectQuestion.valueSelected = answerValue;
  }

  setBadgeMultipleSelectQuestion() {
    this.badgeMultipleQuestions.data = {
      questions: [
        {
          id: 0,
          text: 'not displayed',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 1,
          text: 'face down',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 2,
          text: 'obscured by clock',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 3,
          text: 'obscured by base of windscreen',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 4,
          text: 'obscured by something else',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
      ],
    };
  }
  onBadgeMultipleQuestionsSelected(answerValue) {
    this.badgeMultipleQuestions.valuesSelected = answerValue;
  }

  setClockMultipleSelectQuestion() {
    this.clockMultipleQuestions.data = {
      questions: [
        {
          id: 0,
          text: 'not displayed',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 1,
          text: 'obscured by badge',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 2,
          text: 'obscured by base of windscreen',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 3,
          text: 'obscured by something else',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 4,
          text: 'time not set or wrong time set',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 5,
          text: 'time expired',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
        {
          id: 6,
          text: 'time extended',
          answers: [
            { id: 'y', value: 'Y' },
            { id: 'n', value: 'N' },
          ],
        },
      ],
    };
  }
  onClockMultipleQuestionsSelected(answerValue) {
    this.clockMultipleQuestions.valuesSelected = answerValue;
  }

  setFurtherInfoRadioQuestion() {
    this.furtherInfoRadioQuestion.data = {
      title: this.textCopy.furtherInfoTitle,
      includeTitle: true,
      answers: [
        {
          text: 'enclose a leaflet or separate information',
          value: '0',
        },
        {
          text: 'quote a website address and advise the driver to look at the information online',
          value: '1',
        },
        {
          text: 'do either of the above, depending on the case',
          value: '2',
        },
      ],
    };
  }
  onFurtherInfoRadioQuestionSelected(answerValue) {
    this.furtherInfoRadioQuestion.valueSelected = answerValue;
  }

  setSelectedValues() {
    this.setSelectedContraventions();
    this.secondRadioQuestion.valueSelected = this.policiesAnswers['1_3'];
    this.thirdSelectQuestion.valueSelected = this.policiesAnswers['1_4'];
    this.badgeMultipleQuestions.valuesSelected = [
      { id: 0, value: this.policiesAnswers['1_6_1'] },
      { id: 1, value: this.policiesAnswers['1_6_2'] },
      { id: 2, value: this.policiesAnswers['1_6_3'] },
      { id: 3, value: this.policiesAnswers['1_6_4'] },
      { id: 4, value: this.policiesAnswers['1_6_5'] },
    ];
    this.clockMultipleQuestions.valuesSelected = [
      { id: 0, value: this.policiesAnswers['1_6_7'] },
      { id: 1, value: this.policiesAnswers['1_6_8'] },
      { id: 2, value: this.policiesAnswers['1_6_9'] },
      { id: 3, value: this.policiesAnswers['1_6_10'] },
      { id: 4, value: this.policiesAnswers['1_6_11'] },
      { id: 5, value: this.policiesAnswers['1_6_12'] },
      { id: 6, value: this.policiesAnswers['1_6_13'] },
    ];
    this.furtherInfoRadioQuestion.valueSelected = this.policiesAnswers['1_7'];
    this.furtherInfoTextarea = this.policiesAnswers['1_8'];
  }

  setSelectedContraventions() {
    this.reportsService.getOffences().subscribe((result) => {
      this.contraventionsQuestion.valuesSelected = [];
      result.forEach((contravention) => {
        // no contravention 15 and 77 for policies
        if (contravention.id === 15 || contravention.id === 77) {
          return;
        }
        const value = this.policiesAnswers[`1_2_${contravention.id}`];
        this.contraventionsQuestion.valuesSelected.push({
          id: contravention.id,
          value: value !== undefined ? value : 'n',
        });
      });
    });
  }

  onPoliciesAnswersSetted() {
    this.policiesAnswers = this.global.policiesAnswers;
    this.policiesAnswersSetted = this.globalObs.onPoliciesAnswersSetted.subscribe(() => {
      this.setSelectedValues();
    });
  }

  submitPolicyCategory() {
    let policyList = new Array<KeyDescriptionViewModel>();
    policyList = [
      { id: '1_3', description: this.secondRadioQuestion.valueSelected },
      { id: '1_4', description: this.thirdSelectQuestion.valueSelected },
      { id: '1_7', description: this.furtherInfoRadioQuestion.valueSelected },
      { id: '1_8', description: this.furtherInfoTextarea },
    ];

    this.badgeMultipleQuestions.valuesSelected.forEach((selectedValue, index) => {
      policyList.push({ id: `1_6_${index + 1}`, description: selectedValue.value });
    });
    this.clockMultipleQuestions.valuesSelected.forEach((selectedValue, index) => {
      policyList.push({ id: `1_6_${index + 7}`, description: selectedValue.value });
    });
    this.contraventionsQuestion.valuesSelected.forEach((contravention, index) => {
      policyList.push({ id: `1_2_${contravention['id']}`, description: contravention['value'] });
    });

    this.onSavePolicies.emit(policyList);
  }

  ngOnDestroy() {
    if (this.helpServ.isEmpty(this.policiesAnswers)) {
      this.policiesAnswersSetted.unsubscribe();
    }
  }
}
